import DomainEntity from '@/models/DomainEntity'

/**
 * Formations appliquées lors du calcul d'une période.
 * Domaine historiquement écrit par le moteur dans `state.data.training` sans être relu ;
 * conservé tel quel pour ne perdre aucune donnée existante.
 */
export default class StateTrainings extends DomainEntity {
  static get collectionName() {
    return 'statetrainings/'
  }

  static get parentKey() {
    return 'state'
  }

  static defaults() {
    return {
      items: {},
    }
  }
}
